import { LandingConfig } from "../types/home";
import { OnboardingSlide } from "../types/onboarding";
import firstSlide1 from "../pages/Onboarding/assets/first_slide@1x.webp";
import firstSlide2 from "../pages/Onboarding/assets/first_slide@2x.webp";
import firstSlide3 from "../pages/Onboarding/assets/first_slide@3x.webp";
import secondSlide1 from "../pages/Onboarding/assets/second_slide@1x.webp";
import secondSlide2 from "../pages/Onboarding/assets/second_slide@2x.webp";
import secondSlide3 from "../pages/Onboarding/assets/second_slide@3x.webp";
import thirdSlide1 from "../pages/Onboarding/assets/third_slide@1x.webp";
import thirdSlide2 from "../pages/Onboarding/assets/third_slide@2x.webp";
import thirdSlide3 from "../pages/Onboarding/assets/third_slide@3x.webp";

export const defaultLandingConfig: Required<LandingConfig> = {
  background:
    "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Galaxy-Shooters.png",
  video:
    "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Galaxy-Shooter.mp4",
  button: {
    title: { en: "Galaxy Shooters" },
    description: {
      en: "Free to Play",
      af: "Gratis om te speel",
      xh: "Kusimahla Ukudlala",
      nso: "Bapala Mahala",
      "nso-ZA": "Bapala Mahala",
      "bn-BD": "বিনামূল্যে খেলুন",
      nr: "Dlala Mahala",
      zu: "Kumahhala Ukudlala",
    },
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Galaxy-Shooters.png",
  },
};

export const defaultSlides: OnboardingSlide[] = [
  {
    src: { "1x": firstSlide1, "2x": firstSlide2, "3x": firstSlide3 },
    title: {
      en: "Play Everything Here",
      af: "Speel Alles Hier",
      xh: "Dlala Yonke Into Apha",
      nso: "Bapala Tsohle Mo",
      "nso-ZA": "Bapala Tsohle Mo",
      "bn-BD": "সবকিছু এখানে খেলুন",
      nr: "Dlala Koke Lapha",
      zu: "Dlala Konke Lapha",
    },
    description: {
      en: "Discover every game you love in one portal, with instant access to endless fun, challenges, and exclusive content.",
      af: "Ontdek elke speletjie waarvan jy hou op een portaal, met onmiddellike toegang tot eindelose pret, uitdagings en eksklusiewe inhoud.",
      xh: "Fumana yonke imidlalo oyithandayo kwindawo enye, ngokufikelela kwangoko kulonwabo olungapheliyo, imingeni nomxholo okhethekileyo.",
      nso: "Utolla papadi e nngwe le e nngwe yeo o e ratago mo porotaleng e tee, ka phihlelelo ya ka pela ya boithabišo bjo bo sa felego, ditlhohlo le diteng tše kgethegilego.",
      "nso-ZA":
        "Utolla papadi e nngwe le e nngwe yeo o e ratago mo porotaleng e tee, ka phihlelelo ya ka pela ya boithabišo bjo bo sa felego, ditlhohlo le diteng tše kgethegilego.",
      "bn-BD":
        "একটি পোর্টালেই আপনার পছন্দের সব গেম খুঁজে নিন, যেখানে অসীম মজা, চ্যালেঞ্জ এবং এক্সক্লুসিভ কনটেন্টে তাৎক্ষণিক প্রবেশাধিকার রয়েছে।",
      nr: "Thola yonke imidlalo oyithandayo endaweni yinye, ngokufinyelela msinyazana ekuzithabiseni okungapheliko, emincintiswaneni nakokumumethwe okukhethekileko.",
      zu: "Thola yonke imidlalo oyithandayo endaweni eyodwa, ngokufinyelela ngokushesha enjabulweni engapheli, ezinseleleni nakokuqukethwe okukhethekile.",
    },
  },
  {
    src: { "1x": secondSlide1, "2x": secondSlide2, "3x": secondSlide3 },
    title: {
      en: "Climb the Ranks",
      af: "Klim die Ranglys",
      xh: "Nyuka Kumanqanaba",
      nso: "Hlatloga Maemong",
      "nso-ZA": "Hlatloga Maemong",
      "bn-BD": "র‍্যাঙ্কে এগিয়ে যান",
      nr: "Khuphuka Emarhangweni",
      zu: "Khuphuka Emazingeni",
    },
    description: {
      en: "Compete against friends and rivals, track your progress, and rise to the top of the leaderboard.",
      af: "Kompeteer teen vriende en mededingers, volg jou vordering en styg na die top van die ranglys.",
      xh: "Khuphisana nabahlobo nabakhuphisana nawe, landelela inkqubela yakho uze unyukele phezulu kuluhlu lwamanqaku.",
      nso: "Phadišana le bagwera le baphenkgišani, latela tšwelopele ya gago gomme o hlatloge godimo ga lenaneo la maemo.",
      "nso-ZA":
        "Phadišana le bagwera le baphenkgišani, latela tšwelopele ya gago gomme o hlatloge godimo ga lenaneo la maemo.",
      "bn-BD":
        "বন্ধু ও প্রতিদ্বন্দ্বীদের সঙ্গে প্রতিযোগিতা করুন, নিজের অগ্রগতি অনুসরণ করুন এবং লিডারবোর্ডের শীর্ষে উঠুন।",
      nr: "Phikisana nabangani neembangi, landela ituthuko yakho bese ukhuphukela phezulu erhelweni labaphambili.",
      zu: "Qhudelana nabangani nezimbangi, landelela inqubekelaphambili yakho, bese ukhuphukela phezulu ebhodini labaholi.",
    },
  },
  {
    src: { "1x": thirdSlide1, "2x": thirdSlide2, "3x": thirdSlide3 },
    title: {
      en: "Earn & Redeem",
      af: "Verdien en Ruil In",
      xh: "Zuza uze Usebenzise",
      nso: "Hwetša le go Lopolla",
      "nso-ZA": "Hwetša le go Lopolla",
      "bn-BD": "আয় করুন ও রিডিম করুন",
      nr: "Zuza Begodu Uhlenge",
      zu: "Zuza Futhi Uhlenge",
    },
    description: {
      en: "Earn Vodabucks by playing games, then redeem them for data packs, vouchers, and exclusive real-world items.",
      af: "Verdien Vodabucks deur speletjies te speel en ruil dit dan in vir datapakkette, koopbewyse en eksklusiewe werklike items.",
      xh: "Zuza iiVodabucks ngokudlala imidlalo, uze uzisebenzisele iipakethi zedatha, iivawutsha nezinto ezikhethekileyo zokwenene.",
      nso: "Hwetša Vodabucks ka go bapala dipapadi, ke moka o di lopollele dipakana tša data, dikhupone le dilo tše kgethegilego tša nnete.",
      "nso-ZA":
        "Hwetša Vodabucks ka go bapala dipapadi, ke moka o di lopollele dipakana tša data, dikhupone le dilo tše kgethegilego tša nnete.",
      "bn-BD":
        "গেম খেলে Vodabucks আয় করুন, তারপর ডেটা প্যাক, ভাউচার এবং এক্সক্লুসিভ বাস্তব পণ্যের জন্য সেগুলো রিডিম করুন।",
      nr: "Zuza amaVodabucks ngokudlala imidlalo, bese uwahlengela amaphakethe wedatha, amavawutjha nezinto ezikhethekileko zephila kwamambala.",
      zu: "Zuza ama-Vodabucks ngokudlala imidlalo, bese uwahlengela amaphakethe edatha, amavawusha nezinto ezikhethekile zomhlaba wangempela.",
    },
  },
];
